module.exports = __webpack_public_path__ + "img/py.fa6c6fb2.svg";